import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'convfact-contacttabs',
    templateUrl: './contact-tabs.component.html',
    styleUrls: ['./contact-tabs.component.scss'],
    standalone: false
})
export class ContactTabsComponent {
  routes: object[];

  constructor(private router: Router) {
    this.routes = [
      { label: 'Datos', link: 'edit', enable: true},
      { label: 'Cuentas Bancarias', link: 'bank-accounts', enable: true},
      { label: 'Centros', link: 'center', enable: true},
      { label: 'Portal del cliente', link: 'portal', enable: true},
    ];
  }
}
